export default __webpack_public_path__ + "static/media/diagnosis_overlay_img_placeholder.13f89adb.png";